/* ============================================================
   GREAT PRIMATE™ — THEME.JS
   Interactions · v2.0
   ============================================================ */

(function(){
  'use strict';

  /* ---- HELPERS ---- */
  const $  = (s,c) => (c||document).querySelector(s);
  const $$ = (s,c) => [...(c||document).querySelectorAll(s)];

  /* ============================================================
     1. HEADER — scroll show/hide, background
     ============================================================ */
  const header = $('#site-header');
  if(header){
    let lastY = 0, ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      if(y > 80) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
      if(y > 400 && y > lastY + 5) header.classList.add('is-hidden');
      else if(y < lastY - 5) header.classList.remove('is-hidden');
      lastY = y;
      ticking = false;
    };
    window.addEventListener('scroll', () => { if(!ticking){ requestAnimationFrame(onScroll); ticking = true; } }, {passive:true});
  }

  /* ============================================================
     2. MOBILE DRAWER
     ============================================================ */
  const drawer    = $('#mobile-drawer');
  const overlay   = $('#drawer-overlay');
  const openBtn   = $('#menu-open');
  const closeBtn  = $('#menu-close');

  function openDrawer(){
    if(!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    openBtn && openBtn.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(){
    if(!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    openBtn && openBtn.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
  }
  openBtn  && openBtn.addEventListener('click', openDrawer);
  closeBtn && closeBtn.addEventListener('click', closeDrawer);
  overlay  && overlay.addEventListener('click', closeDrawer);

  /* ============================================================
     3. SEARCH OVERLAY
     ============================================================ */
  const searchToggle  = $('#search-toggle');
  const searchOverlay = $('#search-overlay');
  const searchClose   = $('#search-close');
  const searchInput   = $('#search-input');

  function openSearch(){
    if(!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden','false');
    setTimeout(() => searchInput && searchInput.focus(), 100);
  }
  function closeSearch(){
    if(!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden','true');
  }
  searchToggle && searchToggle.addEventListener('click', openSearch);
  searchClose  && searchClose.addEventListener('click', closeSearch);
  document.addEventListener('keydown', e => { if(e.key === 'Escape'){ closeSearch(); closeDrawer(); closeSizeGuide(); } });

  /* ============================================================
     4. MEGA MENU — keyboard + touch accessibility
     ============================================================ */
  const megaDrop = $('.nav-drop--mega');
  const megaMenu = $('#mega-menu');
  if(megaDrop && megaMenu){
    let closeTimer;
    megaDrop.addEventListener('mouseenter', () => { clearTimeout(closeTimer); megaMenu.classList.add('is-open'); });
    megaDrop.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => megaMenu.classList.remove('is-open'), 200); });
    const dropLink = $('.nav-link--drop', megaDrop);
    if(dropLink){
      dropLink.addEventListener('focus', () => megaMenu.classList.add('is-open'));
    }
  }

  /* ============================================================
     5. PRODUCT GALLERY — thumbnail click
     ============================================================ */
  // The frame holds two images: the blurred backdrop first, then the
  // photograph. Target the photograph by id, and keep the backdrop in step so
  // the blur behind a swapped shot is that shot and not the first one.
  const galleryMain     = $('#product-main-img');
  const galleryBackdrop = $('.gp-product__gallery-main .img-backdrop');
  const galleryThumbs   = $$('.gp-product__gallery-thumb');
  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      galleryThumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const img = $('img', thumb);
      if(galleryMain && img){
        galleryMain.src    = img.dataset.full || img.src.replace(/width=\d+/, 'width=800');
        galleryMain.srcset = '';
        galleryMain.alt    = img.alt;
        if(galleryBackdrop) galleryBackdrop.src = img.src.replace(/width=\d+/, 'width=40');
      }
    });
  });

  /* ============================================================
     6. PRODUCT — VARIANT SELECTOR

     Picking an option has to do three things beyond looking selected:
     resolve the real variant, put its id in every add-to-cart form on the
     page (the main one and the sticky bar), and show that colourway's photo.
     ============================================================ */
  let productVariants = null;
  const variantJson = $('[data-product-variants]');
  if(variantJson){
    try { productVariants = JSON.parse(variantJson.textContent); }
    catch(e){ productVariants = null; }
  }

  const selectOption = btn => {
    const group = btn.closest('.gp-product__options');
    if(group){
      $$('.gp-product__option-btn', group).forEach(b => {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
    }
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');
  };

  const chosenOptions = () =>
    $$('.gp-product__options').map(group => {
      const on = $('.gp-product__option-btn.is-selected', group);
      return on ? on.dataset.optionValue : null;
    });

  const applyVariant = () => {
    if(!productVariants || !productVariants.length) return;
    const want  = chosenOptions();
    const match = productVariants.find(v =>
      v.options.length === want.length && v.options.every((o, i) => o === want[i]));
    if(!match) return;

    $$('form[data-add-to-cart] [name="id"]').forEach(i => { i.value = match.id; });

    // only touch the price when there is a real one — a $0 variant renders as
    // "Coming very soon" and must not be overwritten with $0.00
    const priceEl = $('#product-price');
    if(priceEl && match.priceRaw > 0) priceEl.textContent = match.price;

    $$('form[data-add-to-cart] button[type="submit"]').forEach(b => {
      b.disabled    = !match.available;
      b.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    });

    // gallery by colour: show only thumbs tagged with the chosen colour (or
    // untagged ones). The Liquid emits data-colour-index only when the product
    // has a Color option, so everything else is left alone.
    const thumbsWrap  = $('.gp-product__gallery-thumbs');
    const colourIndex = thumbsWrap && thumbsWrap.dataset.colourIndex
      ? parseInt(thumbsWrap.dataset.colourIndex, 10) : NaN;
    const filtering   = !Number.isNaN(colourIndex) && galleryThumbs.length > 0;
    let colourChanged = true;
    if(filtering){
      const colour = String(match.options[colourIndex]).toLowerCase();
      colourChanged = (thumbsWrap.dataset.currentColour || '') !== colour;
      thumbsWrap.dataset.currentColour = colour;
      galleryThumbs.forEach(thumb => {
        const tag = thumb.dataset.colour;
        thumb.hidden = !!tag && tag.toLowerCase() !== colour;
      });
    }

    // Only move the main image when the colourway changed or the current shot
    // is no longer visible, so picking a size keeps the view the shopper chose.
    const active = galleryThumbs.find(t => t.classList.contains('is-active'));
    if(match.imageId && (colourChanged || !active || active.hidden)){
      const thumb = $(`.gp-product__gallery-thumb[data-image-id="${match.imageId}"]`);
      if(thumb){
        thumb.click();
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    // never leave the main image on a colour that is now hidden
    if(filtering){
      const nowActive = galleryThumbs.find(t => t.classList.contains('is-active'));
      if(!nowActive || nowActive.hidden){
        const first = galleryThumbs.find(t => !t.hidden);
        if(first) first.click();
      }
    }
  };

  $$('.gp-product__option-btn').forEach(btn => {
    btn.setAttribute('aria-pressed', btn.classList.contains('is-selected') ? 'true' : 'false');
    btn.addEventListener('click', () => {
      selectOption(btn);
      applyVariant();
    });
  });

  /* ============================================================
     7. PRODUCT — QUANTITY SELECTOR
     ============================================================ */
  $$('.gp-product__qty').forEach(wrap => {
    const input = $('input', wrap);
    const minus = $('[data-qty="minus"]', wrap);
    const plus  = $('[data-qty="plus"]', wrap);
    if(!input) return;
    minus && minus.addEventListener('click', () => { const v = parseInt(input.value)||1; input.value = Math.max(1, v-1); });
    plus  && plus.addEventListener('click',  () => { const v = parseInt(input.value)||1; input.value = v+1; });
  });

  /* ============================================================
     8. PRODUCT — STICKY ATC BAR
     ============================================================ */
  const mainATC   = $('.gp-product__atc');
  const stickyATC = $('.gp-product__sticky-atc');
  if(mainATC && stickyATC){
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        stickyATC.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { threshold:0 });
    obs.observe(mainATC);
  }

  /* ============================================================
     9. PRODUCT — ACCORDION
     ============================================================ */
  $$('.gp-product__accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const content = trigger.nextElementSibling;
      const inner   = content && $('.gp-product__accordion-content-inner', content);
      const isOpen  = trigger.classList.contains('is-open');
      // Close all
      $$('.gp-product__accordion-trigger').forEach(t => {
        t.classList.remove('is-open');
        const c = t.nextElementSibling;
        if(c) c.style.maxHeight = '0';
      });
      // Toggle current
      if(!isOpen && content && inner){
        trigger.classList.add('is-open');
        content.style.maxHeight = inner.offsetHeight + 'px';
      }
    });
  });

  /* ============================================================
     10. SIZE GUIDE MODAL
     ============================================================ */
  const sizeGuideModal = $('.size-guide-modal');
  function openSizeGuide(){
    if(!sizeGuideModal) return;
    sizeGuideModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeSizeGuide(){
    if(!sizeGuideModal) return;
    sizeGuideModal.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  $$('.gp-product__size-guide').forEach(el => el.addEventListener('click', openSizeGuide));
  if(sizeGuideModal){
    $('.size-guide-modal__close', sizeGuideModal)?.addEventListener('click', closeSizeGuide);
    sizeGuideModal.addEventListener('click', e => { if(e.target === sizeGuideModal) closeSizeGuide(); });
  }

  /* ============================================================
     11. COLLECTION — FILTER PILLS
     ============================================================ */
  const filterPills = $$('.gp-collection__filter-pill');
  const collGrid    = $('.gp-collection__grid');
  const collEmpty   = $('.gp-collection__empty');
  /* The grid item is the .reveal wrapper around each card, not the
     <article class="product-card"> inside it. Hiding the article left
     the wrapper still holding its cell, so filtering punched empty holes
     in the grid instead of letting it reflow — the "weird behaviour"
     reported. Operate on the grid's own children. */
  const collItems = collGrid ? $$(':scope > *', collGrid) : [];

  const applyCollFilter = tag => {
    let shown = 0;
    collItems.forEach(item => {
      const card = item.matches('.product-card') ? item : $('.product-card', item);
      if(!card) return;
      /* Match whole tags. A substring test made "tee" match "steel-tee"
         and "cotton" match "organic-cotton". */
      const tags  = (card.dataset.tags || '').toLowerCase().split(',').map(t => t.trim());
      const match = !tag || tag === 'all' || tags.indexOf(tag.toLowerCase()) !== -1;
      item.hidden = !match;
      if(match) shown++;
    });
    if(collEmpty) collEmpty.hidden = shown > 0;
  };

  filterPills.forEach(pill => {
    pill.addEventListener('click', () => {
      filterPills.forEach(p => {
        p.classList.remove('is-active');
        p.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('is-active');
      pill.setAttribute('aria-pressed', 'true');
      applyCollFilter(pill.dataset.tag);
    });
  });

  /* ============================================================
     12. COLLECTION — GRID/LIST VIEW TOGGLE
     ============================================================ */
  const viewBtns = $$('.gp-collection__view-btn');
  viewBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      viewBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      if(collGrid){
        collGrid.classList.toggle('gp-collection__grid--list', btn.dataset.view === 'list');
      }
    });
  });

  /* ============================================================
     13. ADD TO CART — AJAX
     ============================================================ */
  $$('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = $('button[type="submit"]', form);
      const variantId = $('[name="id"]', form)?.value;
      const qty = $('[name="quantity"]', form)?.value || 1;
      if(!variantId) return;

      btn && (btn.disabled = true, btn.textContent = 'Adding…');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: parseInt(qty) }] })
        });
        if(!res.ok) throw new Error('Add to cart failed');
        const data = await res.json();
        showToast(data.items?.[0]?.title ? `${data.items[0].title} added to cart` : 'Added to cart');
        // Update cart badge
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const badge = $('#cart-badge');
        if(badge) badge.textContent = cart.item_count;
        else {
          const cartIcon = $('a[aria-label*="Cart"]');
          if(cartIcon){
            const span = document.createElement('span');
            span.className = 'cart-badge';
            span.id = 'cart-badge';
            span.textContent = cart.item_count;
            cartIcon.appendChild(span);
          }
        }
      } catch(err) {
        showToast('Could not add to cart. Please try again.');
        console.error(err);
      } finally {
        btn && (btn.disabled = false, btn.textContent = 'Add to Cart');
      }
    });
  });

  /* ============================================================
     14. TOAST NOTIFICATION
     ============================================================ */
  const toast = $('#toast');
  let toastTimer;
  function showToast(msg){
    if(!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3000);
  }

  /* ============================================================
     15. SCROLL REVEAL (IntersectionObserver)
     ============================================================ */
  const revealEls = $$('.reveal');
  if(revealEls.length){
    const revealObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if(e.isIntersecting){
          e.target.classList.add('is-visible');
          revealObs.unobserve(e.target);
        }
      });
    }, { threshold:0.1, rootMargin:'0px 0px -40px 0px' });
    revealEls.forEach(el => revealObs.observe(el));
  }

  /* ============================================================
     16. PAGE TRANSITIONS
     ============================================================ */
  document.addEventListener('click', e => {
    const link = e.target.closest('a[href]');
    if(!link) return;
    const url = link.getAttribute('href');
    // Only intercept internal navigation links
    if(!url || url.startsWith('#') || url.startsWith('javascript') || url.startsWith('mailto') || url.startsWith('tel') || link.target === '_blank' || e.ctrlKey || e.metaKey) return;
    if(url.startsWith('http') && !url.includes(window.location.hostname)) return;
    e.preventDefault();
    document.body.classList.add('is-loading');
    setTimeout(() => { window.location.href = url; }, 250);
  });
  window.addEventListener('pageshow', () => {
    document.body.classList.remove('is-loading');
  });

  /* ============================================================
     17. LAZY LOAD IMAGES (native + blur placeholder)
     ============================================================ */
  $$('img[loading="lazy"]').forEach(img => {
    if(img.complete) img.classList.add('is-loaded');
    else img.addEventListener('load', () => img.classList.add('is-loaded'), {once:true});
  });

  /* ============================================================
     18. NEWSLETTER — redirect to thank-you page after signup
     Shopify appends ?customer_posted=true to the current URL after
     a successful 'customer' form submission. return_to is not
     reliably honoured for this form type, so redirect from here
     instead. The inline .gp-footer__newsletter-msg--success
     (rendered server-side via form.posted_successfully?) is the
     no-JS fallback — this only upgrades the experience when JS runs.
     ============================================================ */
  if(/(^|[?&])customer_posted=true(&|$)/.test(window.location.search) && window.location.pathname.indexOf('/pages/thank-you') === -1){
    window.location.replace('/pages/thank-you');
  }

})();
